import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import CopyToClipboard from 'react-copy-to-clipboard';
import styled from '@emotion/styled';
import Fa from 'components/fa';

const Wrapper = styled.div`
  margin: ${props => props.margin};
  position: relative;
  cursor: pointer;
`;

const Text = styled.span`
  display: inline-block;
  margin-left: 5px;
`;

const TextWrapper = styled.span`
  display: flex;
  align-items: center;
  i {
    color: ${props => props.color};
  }
`;

const Message = styled.div`
  position: absolute;
  bottom: -40px;
  font-size: 12px;
  background: #ff8700;
  color: white;
  padding: 5px;
  left: -20px;
`;

@observer
class Copy extends React.Component {
  @observable messageIsDisplayed = false;
  showMessage = () => {
    this.messageIsDisplayed = true;
    setTimeout(this.hideMessage, 1300);
  }
  hideMessage = () => {
    this.messageIsDisplayed = false;
  }

  escapeHtml = (value) => {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  blobToDataUrl = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  imageSrcForCopy = async (imageUrl) => {
    try {
      const response = await fetch(imageUrl);
      if (response.ok) {
        const blob = await response.blob();
        return await this.blobToDataUrl(blob);
      }
    } catch (e) {
    }
    return imageUrl;
  }

  htmlBlobForCopy = async () => {
    if (this.props.copyItems) {
      const itemHtml = await Promise.all(this.props.copyItems.map(async item => {
        const imageSrc = item.imageUrl ? await this.imageSrcForCopy(item.imageUrl) : null;
        const imageHtml = imageSrc ? `<img src="${this.escapeHtml(imageSrc)}" />` : '';
        return `<div>${imageHtml}<pre>${this.escapeHtml(item.text || '')}</pre></div>`;
      }));
      return new Blob([itemHtml.join('<hr />')], { type: 'text/html' });
    }

    const text = this.props.text || '';
    const imageSrc = await this.imageSrcForCopy(this.props.imageUrl);
    const html = `<div><img src="${this.escapeHtml(imageSrc)}" /><pre>${this.escapeHtml(text)}</pre></div>`;
    return new Blob([html], { type: 'text/html' });
  }

  copyWithImage = async () => {
    const text = this.props.text || '';
    try {
      if (navigator.clipboard?.write && window.ClipboardItem) {
        await navigator.clipboard.write([
          new ClipboardItem({
            'text/plain': Promise.resolve(new Blob([text], { type: 'text/plain' })),
            'text/html': this.htmlBlobForCopy(),
          }),
        ]);
      } else if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
      }
      this.showMessage();
    } catch (e) {
      try {
        await navigator.clipboard.writeText(text);
        this.showMessage();
      } catch (err) {
      }
    }
  }

  renderCopyContent = (onClick) => {
    return (
      <TextWrapper
        color={this.props.color}
        onClick={onClick}
      >
        {
          !this.props.hideIcon &&
            <Fa i='copy' />
        }
        {
          this.props.children &&
            <Text>
              {this.props.children}
            </Text>
        }
      </TextWrapper>
    );
  }

  render() {
    return (
      <Wrapper
        margin={this.props.margin}
      >
        {
          (this.props.imageUrl || this.props.copyItems?.some(item => item.imageUrl)) &&
            this.renderCopyContent(this.copyWithImage)
        }
        {
          !this.props.imageUrl && !this.props.copyItems?.some(item => item.imageUrl) &&
            <CopyToClipboard
              text={this.props.text}
              onCopy={this.showMessage}
            >
              {this.renderCopyContent()}
            </CopyToClipboard>
        }
        {
          this.messageIsDisplayed &&
            <Message>
              copied!
            </Message>
        }
      </Wrapper>
    );
  }
}

export default Copy;
